/* Distributor directory: drop every partner pin on one map (tabs filter cards only). */
(function () {
  var PIN_HTML = '<span class="distributor-pin__dot"></span>';

  function parsePoints(root) {
    var el = (root || document).querySelector('[data-distributor-points]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; }
    catch (e) { return []; }
  }

  function pinIcon() {
    return window.L.divIcon({
      className: 'distributor-pin',
      html: PIN_HTML,
      iconSize: [22, 28],
      iconAnchor: [11, 28],
      popupAnchor: [0, -24]
    });
  }

  function fitAll(map, markers) {
    if (!markers.length) return;
    var group = window.L.featureGroup(markers);
    map.fitBounds(group.getBounds().pad(0.18), { maxZoom: 4, animate: false });
  }

  function initLeaflet(root) {
    var canvas = (root || document).querySelector('[data-distributor-map-canvas]');
    if (!canvas || canvas.getAttribute('data-map-ready') === '1') return false;
    if (!window.L) return false;
    var points = parsePoints(root).filter(function (p) {
      return p && isFinite(p.lat) && isFinite(p.lng);
    });
    if (!points.length) return false;

    canvas.setAttribute('data-map-ready', '1');
    var map = window.L.map(canvas, {
      scrollWheelZoom: false,
      attributionControl: true
    });
    window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    var icon = pinIcon();
    var byId = {};
    var markers = points.map(function (p) {
      var label = [p.name, p.country].filter(Boolean).join(' — ');
      var marker = window.L.marker([p.lat, p.lng], { icon: icon, title: label }).addTo(map);
      if (label) marker.bindPopup(label);
      if (p.id) byId[p.id] = marker;
      return marker;
    });
    fitAll(map, markers);
    requestAnimationFrame(function () { map.invalidateSize(); fitAll(map, markers); });

    (root || document).querySelectorAll('[data-map-id]').forEach(function (card) {
      if (card.getAttribute('data-map-bound') === '1') return;
      card.setAttribute('data-map-bound', '1');
      card.addEventListener('click', function () {
        var marker = byId[card.getAttribute('data-map-id')];
        if (!marker) return;
        canvas.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        map.flyTo(marker.getLatLng(), Math.max(map.getZoom(), 8), { duration: 0.6 });
        marker.openPopup();
      });
    });
    return true;
  }

  function initIframeFallback(root) {
    var maps = (root || document).querySelectorAll('[data-distributor-map]');
    if (!maps.length) return;
    (root || document).querySelectorAll('[data-map-q]').forEach(function (card) {
      if (card.getAttribute('data-map-iframe-bound') === '1') return;
      card.setAttribute('data-map-iframe-bound', '1');
      card.addEventListener('click', function () {
        if ((root || document).querySelector('[data-distributor-map-canvas][data-map-ready="1"]')) return;
        var q = card.getAttribute('data-map-q');
        if (!q) return;
        var src = 'https://maps.google.com/maps?q=' + encodeURIComponent(q) + '&z=12&output=embed';
        maps.forEach(function (iframe) {
          iframe.hidden = false;
          iframe.classList.remove('visually-hidden');
          iframe.src = src;
        });
      });
    });
  }

  function init(root) {
    var ok = initLeaflet(root);
    if (!ok) {
      (root || document).querySelectorAll('[data-distributor-map]').forEach(function (iframe) {
        iframe.hidden = false;
        iframe.classList.remove('visually-hidden');
      });
      initIframeFallback(root);
    }
  }

  if (window.theme && window.theme.register) window.theme.register(init);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
})();
